import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AddComment, LoadComments } from './state/comments.actions';
import { MessageEntityType, PostCommentPayload } from './comments.model';
import { CommentsSelectors } from './state/comments.selectors';
import { forceArray } from '@aiwyn/shared';

/**
 * Service layer for dispatching comments actions to NGXS store
 */
@Injectable({ providedIn: 'root' })
export class CommentsService {
  private readonly store = inject(Store);

  /**
   * Load comments from the API for one or more entities
   */
  loadComments(entityIds: number[], entityType: MessageEntityType, limit = 50): void {
    this.store.dispatch(new LoadComments(forceArray(entityIds), entityType, limit));
  }

  /**
   * Add a new comment or reply
   */
  addComment(payload: PostCommentPayload): void {
    this.store.dispatch(new AddComment(payload));
  }

  /**
   * Post a comment (convenience method)
   */
  postComment(comment: PostCommentPayload): void {
    this.addComment(comment);
  }

  /**
   * Get loading state
   */
  isLoading(): Observable<boolean> {
    return this.store.select(CommentsSelectors.loading);
  }

  /**
   * Get error state
   */
  getError(): Observable<string | null> {
    return this.store.select(CommentsSelectors.error);
  }
}
